interface IProps {
    data: { label: string; url: string; icon?: string };
}

const Btn = (props: IProps) => {
    const { data } = props;
    return (
        <a href={data.url} key={data.url} target="_blank">
            <div className="btn">
                {/* {data.icon && (
                    <div className="icon">
                        <i className={data.icon}></i>
                    </div>
                )} */}
                {data.label}
            </div>
        </a>
    );
};

export default Btn;
